import React from 'react';
import { H2, Paragraph } from '../../theme';
import { Dialog, DialogContent, DialogContentText, Box } from '@mui/material';
import { ModalProps } from '../../utils/types';
import CloseIcon from './CloseIcon';

const AutoClaimsModal = ({ open, handleClose }:ModalProps): JSX.Element => {
    return (
        <Dialog
            maxWidth='lg'
            fullWidth={true}
            open={open}
            onClose={handleClose}
        >
            <DialogContent sx={{ padding: '30px' }}>
                <CloseIcon handleClose={handleClose}/>
                <DialogContentText>
                    <Box>
                        <H2>Auto Claims</H2>
                        <Paragraph>
                            For auto incidents, we first bill a patient's medical insurance and if medical insurance denies the claim,
                            we will then try billing auto insurance. If both attempts are unsuccessful, we will then bill the patient our cash pay price.
                            We are happy to provide receipts in case patients want to try to get reimbursed from their insurer, but we can make no guarantees about reimbursement.
                            That would be between the patient and their insurer.
                        </Paragraph>
                    </Box>
                </DialogContentText>
            </DialogContent>
        </Dialog>
    );
};

export default AutoClaimsModal;
